import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import Image from "../../Components/Reusable/Image";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import FormModal from "../../Components/modal/FormModal";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import DistrictService from "../../Services/DistrictService";
import StateService from "../../Services/StateService";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import { AuthContext } from "../../Context/authContext";

const DistrictMaster = () => {
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [searchQuery, setSearchQuery] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const { user } = useContext(AuthContext)

  // Form validation schema using Yup
  const addSchema = Yup.object().shape({
    name: validationRegex.required,
    state: validationRegex.required,
  });

  const editSchema = Yup.object().shape({
    name: validationRegex.required,
  });

  const {
    register: registerAdd,
    handleSubmit: handleSubmitAdd,
    formState: { errors: errorsAdd },
    reset: resetAdd,
    setValue: setAddValues,
  } = useForm({
    resolver: yupResolver(addSchema),
    defaultValues: {
      name: "",
      state: "",
    },
  });

  const {
    register: registerEdit,
    handleSubmit: handleSubmitEdit,
    formState: { errors: errorsEdit },
    reset: resetEdit,
    setValue: setEditValues,
  } = useForm({
    resolver: yupResolver(editSchema),
    defaultValues: {
      name: "",
    },
  });

  // Function to handle opening add modal
  const handleOpenAddModal = () => {
    getAllStates();
    resetAdd(); // Reset form fields when opening Add modal
    setShowAddModal(true);
  };

  // Function to handle opening edit modal
  const handleOpenEditModal = (item) => {
    setEditValues("name", item.name);
    setEditData(item);
    setShowEditModal(true);
  };

  const getAllStates = async () => {
    try {
      const response = await StateService.getAll();
      setStates(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    getAllStates();
  }, [])

  const fetchData = async (state_id = selectedState) => {
    try {
      const response = await DistrictService.get(
        offset,
        limit,
        searchQuery || "",
        state_id
      );
      setData(response.data);

      setAvailableDataCount(response.availableDataCount);

      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const addDataApiTask = async (data) => {
    try {
      await DistrictService.create(data.name, data.state);
      setShowAddModal(false);
      toast.success("District added successfully");
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const updateApiTask = async (params) => {
    try {
      await DistrictService.update(editData._id, params.name.trim());

      setShowEditModal(false);
      toast.success("District updated successfully");

      var updatedData = data;
      const index = updatedData.findIndex((item) => item._id === editData._id);
      updatedData[index].name = params.name.trim();
      setData(updatedData);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteSingleData = async (id) => {
    try {
      await DistrictService.delete([id]);
      toast.success("District Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteMultipleData = async () => {
    try {
      if (data.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item._id);
          }
        });
      }
      await DistrictService.delete(itemsToDelete);
      toast.success("Districts Deleted successfully");
      setShowDeleteModal(false);

      setOffset(0);
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const ChangeStatus = async (id, status) => {
    try {
      await DistrictService.changeStatus(id, status);
      toast.success("District Status Updated successfully");
      var updatedData = data;
      updatedData[updatedData.findIndex((item) => item._id === id)].is_active = status;
      setData(updatedData);
      setShowConfirmationModal(false);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);

  const handleFilterChange = (state_id) => {
    setSelectedState(state_id); // Set the selected state ID
    console.log(state_id, "statename"); // Log the state ID and the string "statename"

    // Logic for handling the filter change (fetching data with or without state_id)
    if (state_id === "") {
      fetchData(state_id); // Fetch all districts if state_id is empty
      setOffset(0); // Reset offset to 0
    } else {
      fetchData(state_id); // Fetch data based on the selected state ID
      setOffset(0); // Reset offset to 0
    }
  };
  useEffect(() => {
    fetchData();
  }, [offset]);

  return (
    <div>
      <div>
        <div className="content" data-number="1">
          <div className="mb-3 d-flex justify-content-between align-items-center">
            <h1 className="black fs-18 fw-600 mb-0">DISTRICT MASTER</h1>
            <div className="d-flex">
              <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
              <h4 className="fs-12 fw-500 primary mb-0">District Master</h4>
            </div>
          </div>

          <div className="table_container" style={{ display: "block" }}>
            <h1 className="black fs-18 fw-600 mb-0">District List</h1>
            <div className="table_title">
              <div className="table_headings row mt-2 ResposiveHeadersection ">

                <div className="d-flex  col-md-5 gap-3 align-items-center filter-range Responsive">
                  <div
                    className="table_delete_icon"
                    style={{
                      opacity:
                        data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                      pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                    }}
                    onClick={() => {

                      const districtMasterPrivilege = user?.setPrivileges?.find(
                        (priv) => priv.parameter === "District Master"
                      );
                      if (!districtMasterPrivilege?.delete) {
                       
                        toast.warning("You don't have permission to delete district list.");
                        return;
                      }

                      if (!(data.findIndex((item) => item.isChecked) == -1)) {
                        setIsMultipleDelete(true);
                        setShowDeleteModal(true);
                      }
                    }}
                  >
                    <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
                  </div>

                  <CustomDropDown
                    placeholder="Filter By State"
                    inputType={InputType.text}
                    onChange={(selectedOption) =>handleFilterChange(selectedOption?.value || "")}
                    Dropdownclass={"col-md-6"}
                    options={
                      [{ value: "", label: "All" }, ...states?.map((e) => { return { value: e._id, label: e.name } }) ?? []]
                    }

                  // defaultOption={
                  //   { value: "", label: "All" }
                  // }
                  />

                </div>

                <div className="d-flex gap-4 col-md-7 align-items-center justify-content-end Responsivesection">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="search_box search_bar"
                      placeholder="Search"
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <Image
                      src={SvgImages.search}
                      style={ImageFilters.gray}
                      className="search_icon"
                      alt="Search Icon"
                      height="20px"
                    />
                  </div>
                  <ButtonWithIcon
                    text={"Add District"}
                    icon={SvgImages.plus}
                    onClick={() => {
                      const districtMasterPrivilege = user?.setPrivileges?.find(
                        (priv) => priv.parameter === "District Master"
                      );

                      if (districtMasterPrivilege?.create) {
                       
                        handleOpenAddModal(); // Open modal if create is true
                      } else {
                       
                        toast.warning("You don't have permission to add a district.");
                      }
                    }}
                  />
                </div>
              </div>
            </div>




            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead>
                  <tr className="table_heading">
                    <th scope="col" style={{ width: "5%" }}>
                      <label className="d-flex align-items-center justify-content-center">
                        <input
                          className="cursor-pointer"
                          type="checkbox"
                          style={{ height: "16px", aspectRatio: 1 }}
                          checked={
                            data?.length > 0 &&
                            data?.findIndex((item) => !item.isChecked) == -1
                          }
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData.map((element) => {
                              element.isChecked = value.target.checked;
                            });
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </th>
                    <th scope="col" style={{ width: "10%" }}>
                      Sr No.
                    </th>
                    <th scope="col" style={{ width: "25%" }}>
                      State
                    </th>
                    <th scope="col" style={{ width: "30%" }}>
                      District
                    </th>
                    <th scope="col" style={{ width: "15%" }}>
                      Status
                    </th>
                    <th scope="col" style={{ width: "10%" }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg_light">
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <label className="d-flex align-items-center justify-content-center">
                          <input
                            className="cursor-pointer"
                            type="checkbox"
                            checked={item.isChecked || false}
                            style={{ height: "16px", aspectRatio: 1 }}
                            onChange={(value) => {
                              var updatedData = data;
                              updatedData[index].isChecked =
                                value.target.checked;
                              setData([...updatedData]);
                            }}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </td>
                      <td>{limit * offset + (index + 1)}</td>
                      <td>{item.state.name}</td>
                      <td>{item.name}</td>
                      <td>
                        <label
                          className="switch"
                        >
                          <input
                            type="checkbox"
                            checked={item.is_active}
                            onChange={() => {
                              const districtMasterPrivilege = user?.setPrivileges?.find(
                                (priv) => priv.parameter === "District Master"
                              )
                              if (!districtMasterPrivilege?.update) {
                               
                                toast.warning("You don't have permission to update the status.");
                                return;
                              }

                              setShowConfirmationModal(true);
                              setStatusChangeData(item);
                            }}
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>
                      <td>
                        <div className="d-flex gap_8">
                          <a
                            onClick={() => {

                              const districtMasterPrivilege = user?.setPrivileges?.find(
                                (priv) => priv.parameter === "District Master"
                              );

                              if (!districtMasterPrivilege?.update) {
                               
                                toast.warning("You don't have permission to edit district.");
                                return;
                              }
                              handleOpenEditModal(item)
                            }}
                            className="edit_icons cursor-pointer"
                          >
                            <Image
                              src={SvgImages.edit}
                              style={ImageFilters.green}
                              className="add_icons"
                              alt="Edit Icon"
                            />
                          </a>
                          <a
                            className="delete_icons cursor-pointer"
                            onClick={() => {
                              const districtMasterPrivilege = user?.setPrivileges?.find(
                                (priv) => priv.parameter === "District Master"
                              );
                              if (!districtMasterPrivilege?.delete) {
                               
                                toast.warning("You don't have permission to delete district.");
                                return;
                              }

                              setDeleteId(item._id);
                              setIsMultipleDelete(false);
                              setShowDeleteModal(true);
                            }}
                          >
                            <Image
                              src={SvgImages.deleteIcon}
                              style={ImageFilters.red}
                              alt="Delete Icon"
                            />
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>


            </div>
            {generatePaginationFooter(
              availableDataCount,
              limit,
              offset,
              setOffset
            )}
          </div>
        </div>
      </div>

      {/* Add District Modal */}
      <FormModal
        title={"Add District"}
        showModal={showAddModal}
        setShowModal={setShowAddModal}
        submitClickAction={handleSubmitAdd(addDataApiTask)}
        children={
          <form onSubmit={handleSubmitAdd(addDataApiTask)}>
            <CustomDropDown
              labelTitle="State"
              placeholder="Select State"
              name="state"
              id="state"
              showError={errorsAdd?.state}
              errorMessage={errorsAdd?.state?.message}
              setValue={setAddValues}
              register={registerAdd}
              additionalClasses="profile_edit"
              inputType={InputType.text}
              showMandatory={true}
              options={
                states.map((e) => { return { value: e._id, label: e.name } })
              }
            />

            <CustomTextField
              labelTitle="District"
              placeholder="Enter district name"
              name="name"
              id="name"
              showError={errorsAdd?.name}
              errorMessage={errorsAdd?.name?.message}
              register={registerAdd}
              additionalClasses="profile_edit"
              showMandatory={true}
            />
          </form>
        }
      />

      {/* Edit District Modal */}
      <FormModal
        title={"Edit District"}
        showModal={showEditModal}
        submitButtonText="Update"
        submitButtonIcon={SvgImages.tick_mark}
        setShowModal={setShowEditModal}
        submitClickAction={handleSubmitEdit(updateApiTask)}
        children={
          <form onSubmit={handleSubmitEdit(updateApiTask)}>
            <CustomTextField
              labelTitle="District"
              placeholder="Enter district name"
              name="name"
              id="name"
              showError={errorsEdit?.name}
              errorMessage={errorsEdit?.name?.message}
              register={registerEdit}
              additionalClasses="profile_edit"
              showMandatory={true}
            />
          </form>
        }
      />

      {/* Delete District Modal */}
      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected data?"
            : "Are you sure want to delete this data?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete
            ? deleteMultipleData()
            : deleteSingleData(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />

      {/* Change District Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => {
          ChangeStatus(getStatusChangeData._id, !getStatusChangeData.is_active);
        }}
        theme={ConfirmationModalTheme.warning}
      />
    </div>
  );
};

export default DistrictMaster;
